export const storeLangSettings = (language) => {
  localStorage.setItem("surveyLanguage", language);
};

export const getLangSettings = () => {
  return localStorage.getItem("surveyLanguage") || "en";
};
